import { Link } from 'react-router-dom';
import { useContext } from 'react';
import { CatalogContext } from 'Catalog/Catalog.context';

export function PrevButton({ children, className }) {
  const to = useContext(CatalogContext).pagingPath.prev;
  return (
    <Link
      to={to}
      className={className}
    >
      {children}
    </Link>
  );
}

export function NextButton({ children, className }) {
  const to = useContext(CatalogContext).pagingPath.next;
  return (
    <Link
      to={to}
      className={className}
    >
      {children}
    </Link>
  );
}
